import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { history } from '../../';

import { isWidthDown } from '@material-ui/core/withWidth';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';

import { tabRoutes } from '../../routes';

import { useStyles, useLinearProgressStyles } from './styles';
import tabbarSlice from './tabbarSlice';

const Tabbar = ({ location, screenWidth }) => {
	const classes = useStyles();
	const linearProgressClasses = useLinearProgressStyles();
	const { pathname } = location;
	const activeTab = useSelector(state => state.tabbar.activeTab);
	const disabledTabs = useSelector(state => state.tabbar.disabledTabs);
	const progressActive = useSelector(state => state.tabbar.progressActive);
	const dispatch = useDispatch();

	useEffect(() => {
		const activateTab = route => {
			dispatch(tabbarSlice.actions.activateTab(route.tabId));
		};

		const newRoute = tabRoutes.find(route => route.path === pathname);

		if (newRoute) {
			activateTab(newRoute);
		} else {
			const inputRoute = tabRoutes.find(route => route.path === '/inputs');

			history.replace(inputRoute.path);
			activateTab(inputRoute);
		}
	}, [dispatch, pathname]);

	const handleTabChange = (_event, tabId) => {
		if (activeTab !== tabId) {
			history.push(tabRoutes.find(route => route.tabId === tabId).path);
		}
	};

	return (
		<AppBar position="fixed" color="inherit" elevation={2} className={classes.tabbar}>
			{progressActive && activeTab !== tabRoutes.find(route => route.path === '/summary').tabId && (
				<LinearProgress classes={linearProgressClasses} />
			)}

			<Tabs
				value={activeTab}
				onChange={handleTabChange}
				variant="scrollable"
				scrollButtons="auto"
				classes={{
					root: classes.tabsRoot,
					scroller: classes.tabsScroller,
					indicator: classes.tabsIndicator
				}}>
				{tabRoutes.map(
					(route, index) =>
						route.tabId !== 5 && (
							<Tab
								key={route.tabId + index}
								label={
									<div className={classes.tabLabelContainer}>
										<Typography variant={isWidthDown('xs', screenWidth) ? 'body2' : 'body1'}>
											<route.tabIcon className={classes.tabIcon} />
											{route.text}
										</Typography>
									</div>
								}
								classes={{
									root: classes.tabRoot,
									selected: classes.tabSelected
								}}
								disabled={disabledTabs[route.name] || progressActive}
								onFocus={event => {
									event.currentTarget.style.backgroundColor = '';
								}}
								onBlur={event => {
									event.currentTarget.style.backgroundColor = '';
								}}
								aria-disabled={disabledTabs[route.name] || progressActive ? 'true' : 'false'}
							/>
						)
				)}
			</Tabs>
		</AppBar>
	);
};

Tabbar.propTypes = {
	location: PropTypes.object.isRequired,
	screenWidth: PropTypes.number.isRequired
};

export default withRouter(Tabbar);
